(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["lk-bundle"] && !Shopify.designMode) return;
  try {
    (function(){
  function bind(root){
    root.querySelectorAll('.lk-bx__opt input').forEach(function(inp){
      if(inp.dataset.lkB)return;inp.dataset.lkB='1';
      inp.addEventListener('change',function(){
        var box=inp.closest('.lk-bx');
        box.querySelectorAll('.lk-bx__opt').forEach(function(l){l.classList.toggle('is-on',l.contains(inp))});
        try{var u=new URL(location.href);u.searchParams.set('variant',inp.value);history.replaceState(null,'',u)}catch(e){}
      });
    });
  }
  function run(){bind(document)}
  if(document.readyState!=='loading'){run()}else{document.addEventListener('DOMContentLoaded',run)}
  document.addEventListener('shopify:block:select',run);document.addEventListener('shopify:section:load',run);
})();
  } catch(e) { console.error(e); }
})();

})();
